import { createFeatureSelector, createSelector } from '@ngrx/store';
import { appConfigAdapter } from './app-config.reducer';

export const selectAppConfigData = createSelector(
  createFeatureSelector('appConfig'),
  appConfigAdapter.getSelectors().selectAll,
);

export const selectGlobalAppOptionsData = createSelector(
  selectAppConfigData,
  (state) => state[0].globalAppConfigModel,
);

export const selectCalendarConfigData = createSelector(
  selectAppConfigData,
  (state) => state[0].calendarConfigModel,
);

export const selectProjectConfigData = createSelector(
  selectAppConfigData,
  (state) => state[0].projectConfigModel,
);

export const selectTodoPlannerConfigData = createSelector(
  selectAppConfigData,
  (state) => state[0].todoPlannerConfigModel,
);
